// eslint-disable-next-line no-restricted-imports
import { Drawer } from '@mui/material';
// eslint-disable-next-line no-restricted-imports
export type { DrawerProps as MuiDrawerProps } from '@mui/material';

export const MuiDrawer = Drawer;
